/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Tags_No_TagsInputs */



/**
* | output |
* | --- |
* | "No Tags(s) Assigned" |
*
* @param {Event_Tags_No_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_tags_no_tags = /** @type {((inputs?: Event_Tags_No_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Tags_No_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune etiquette assignee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Tags zugewiesen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun tag assegnato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метки не назначены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay etiquetas asignadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未分配任何标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグが割り当てられていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई टैग आवंटित नहीं किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma etiqueta atribuída")
	return /** @type {LocalizedString} */ ("No Tags(s) Assigned")
});